import * as React from "react";
import { motion } from "framer-motion";

const Path = (props) => (
  <>
    {/* Outline (behind) */}
    <motion.path
      fill="transparent"
      strokeWidth="5"            
           
      strokeLinecap="round"
      {...props}
    />
    <motion.path
      fill="transparent"
      strokeWidth="3"
      stroke="#ff5a5f"
      strokeLinecap="round"
      {...props}
    />
  </>
);


export const MenuToggle = ({ toggle, isOpen }) => (
  <button onClick={toggle} className="menu-button">
    <svg width="30" height="30" viewBox="0 0 23 23">
      <Path
        variants={{
          closed: { d: "M 2 2.5 L 20 2.5" },
          open: { d: "M 3 16.5 L 17 2.5" },
        }}
        initial={false}
        animate={isOpen ? "open" : "closed"}
      />
      <Path
        d="M 2 9.423 L 20 9.423"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 },
        }}
        transition={{ duration: 0.1 }}
        initial={false}
        animate={isOpen ? "open" : "closed"}
      />
      <Path
        variants={{
          closed: { d: "M 2 16.346 L 20 16.346" },
          open: { d: "M 3 2.5 L 17 16.346" },
        }}
        initial={false}
        animate={isOpen ? "open" : "closed"}
      />
    </svg>
  </button>
);
